import script from "./PaymentsPageCreatorMain.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPageCreatorMain.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPageCreatorMain.vue?vue&type=style&index=0&id=694af394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694af394"]])

export default __exports__